export default "__VITE_ASSET__DaLBLwEu__"